







import { computed, defineComponent } from "@vue/composition-api";
import { getDurationSymbols } from "@/lib/time";

export default defineComponent({
  name: "AudioRecordingDuration",
  props: {
    show: { type: Boolean, default: false },
    durationMs: { type: Number, default: 0 },
  },
  setup(props) {
    const durationText = computed(() => {
      const durationSymbols = getDurationSymbols(props.durationMs);
      const secondsString = durationSymbols.s < 10 ? "0" + `${durationSymbols.s}` : `${durationSymbols.s}`;
      return `${durationSymbols.m}:${secondsString}`;
    });

    return { durationText };
  },
});
